import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useLanguage } from "@/context/LanguageContext";
import MemberHome from "@/pages/MemberHome";

export function ClinicianHome() {
  const { t } = useLanguage();
  const [members, setMembers] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/mi/members")
      .then((r) => setMembers(r.data))
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message));
  }, []);

  return (
    <div className="space-y-8" data-testid="clinician-home">
      <header>
        <div className="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500">
          {t.common.clinician}
        </div>
        <h1 className="mt-1 text-3xl font-semibold tracking-tight text-slate-900">
          {t.clinician.title}
        </h1>
        <p className="mt-1 text-sm text-slate-500">{t.clinician.sub}</p>
      </header>

      {error && <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{error}</div>}

      <div className="mios-card" data-testid="clinician-patients-table">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="border-b border-slate-200 text-[11px] uppercase tracking-[0.06em] text-slate-500">
                <th className="px-5 py-3 font-medium">Name</th>
                <th className="px-5 py-3 font-medium">Email</th>
                <th className="px-5 py-3 font-medium">Language</th>
                <th className="px-5 py-3 font-medium" />
              </tr>
            </thead>
            <tbody>
              {members.map((m) => (
                <tr key={m.id} className="border-b border-slate-100 last:border-0">
                  <td className="px-5 py-3 font-medium text-slate-900">{m.name}</td>
                  <td className="px-5 py-3 text-slate-600 mono">{m.email}</td>
                  <td className="px-5 py-3 text-slate-600 uppercase">{m.language}</td>
                  <td className="px-5 py-3 text-right">
                    <button
                      type="button"
                      className="mios-btn mios-btn-ghost"
                      onClick={() => navigate(`/clinician/${m.id}`)}
                      data-testid={`open-patient-${m.id}`}
                    >
                      {t.clinician.open}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export function ClinicianPatientDetail() {
  const { id } = useParams();
  return <MemberHome targetUserId={id} />;
}
